import { render, staticRenderFns } from "./SecondCopyReceiveDate.vue?vue&type=template&id=730594ee&"
import script from "./SecondCopyReceiveDate.vue?vue&type=script&lang=js&"
export * from "./SecondCopyReceiveDate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports